export enum SelectOfficeVariants {
  Active = 'active',
  Default = 'default',
}
